import { useEffect } from "react";

/**
 * Inject or replace one or more JSON-LD <script type="application/ld+json"> blocks.
 * schemas: array of schema objects. They're upserted by `@id` when present.
 */
export const useJsonLd = (schemas) => {
  const key = JSON.stringify(schemas || []);
  useEffect(() => {
    if (!schemas || schemas.length === 0) return;
    const injected = [];
    schemas.forEach((data, i) => {
      const el = document.createElement("script");
      el.type = "application/ld+json";
      el.setAttribute("data-jsonld", data["@id"] || `page-${i}`);
      el.textContent = JSON.stringify(data);
      document.head.appendChild(el);
      injected.push(el);
    });
    return () => injected.forEach((el) => el.remove());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
};

// Shared org / person
export const personSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  "@id": "https://marketing-ops-18.emergent.host/#shivani",
  name: "Shivani Ranawat",
  jobTitle: "AI Growth Marketing Consultant",
  description:
    "AI Growth Marketing Consultant. 7+ years scaling 50+ international brands across Google Ads, Meta Ads, Amazon DSP and programmatic native with consistent 5–7× ROAS.",
  worksFor: {
    "@type": "Organization",
    "@id": "https://marketing-ops-18.emergent.host/#aiadspace",
    name: "Aiadspace",
  },
  knowsAbout: [
    "AI Marketing",
    "Performance Marketing",
    "Google Ads",
    "Meta Ads",
    "Amazon DSP",
    "Conversion Rate Optimization",
    "GA4",
    "Google Tag Manager",
    "Marketing Automation",
    "Native Advertising",
    "AI Marketing Agents",
    "OTT Marketing",
    "D2C Marketing",
  ],
  sameAs: [
    "https://www.linkedin.com/in/shivani-ranawat-a16929122/",
  ],
  email: "mailto:shivaniranawatdigitalworld@gmail.com",
  url: "https://marketing-ops-18.emergent.host/",
  image: "https://marketing-ops-18.emergent.host/logo512.png",
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://marketing-ops-18.emergent.host/#website",
  name: "The Growth Systems Portfolio — Shivani Ranawat",
  url: "https://marketing-ops-18.emergent.host/",
  publisher: { "@id": "https://marketing-ops-18.emergent.host/#shivani" },
  inLanguage: "en",
};

export const professionalServiceSchema = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": "https://marketing-ops-18.emergent.host/#service",
  name: "Shivani Ranawat · AI Growth Marketing Consulting",
  provider: { "@id": "https://marketing-ops-18.emergent.host/#shivani" },
  areaServed: ["India", "United Arab Emirates", "Singapore", "United Kingdom", "United States"],
  serviceType: [
    "AI Marketing Consulting",
    "Performance Marketing",
    "Google Ads Management",
    "Meta Ads Management",
    "Conversion Rate Optimization",
    "Marketing Automation",
    "GA4 and GTM Setup",
    "AI Marketing Agents",
  ],
  priceRange: "$$$",
  url: "https://marketing-ops-18.emergent.host/services",
};

export const breadcrumb = (crumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map((c, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: c.name,
    item: `https://marketing-ops-18.emergent.host${c.path}`,
  })),
});
